import { render, staticRenderFns } from "./UserGradeReg.vue?vue&type=template&id=07326fd4&scoped=true"
import script from "./UserGradeReg.vue?vue&type=script&lang=js"
export * from "./UserGradeReg.vue?vue&type=script&lang=js"
import style0 from "./UserGradeReg.vue?vue&type=style&index=0&id=07326fd4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07326fd4",
  null
  
)

export default component.exports